<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header">
        <i class="fa fa-file-text"></i> Logs
      </div>
      <div class="card-body">
        <table class="table table-responsive-sm table-hover table-outline mb-0">
          <thead class="thead-light">
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>URL</th>
              <th>HTTP</th>
              <th>Error Code</th>
              <th>Version</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            @for (log of logs; track log.logId; let i = $index) {
              <tr>
                <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                <td>{{ log.createdAtTimestamp !== 0 ? dateService.getDateFromatted(log.createdAtTimestamp) : '-' }}</td>
                <td>
                  <div>{{ log.requestUrl }}</div>
                  @if (log.requestBody) {
                    <small class="text-muted d-block" style="cursor:pointer; word-break:break-all; white-space:pre-wrap; max-width:400px" (click)="toggleBody(log.logId)">
                      @if (expandedBodies.has(log.logId)) {
                        {{ log.requestBody }}
                      } @else {
                        {{ log.requestBody | slice:0:80 }}{{ log.requestBody.length > 80 ? '...' : '' }}
                      }
                    </small>
                  }
                </td>
                <td>
                  <span [class]="log.responseHttpCode >= 400 ? 'badge bg-danger' : 'badge bg-success'">
                    {{ log.responseHttpCode }}
                  </span>
                </td>
                <td>{{ log.responseErrorCode !== 0 ? (ErrorCodes[log.responseErrorCode] ? ErrorCodes[log.responseErrorCode] + '(' + log.responseErrorCode + ')' : log.responseErrorCode) : '-' }}</td>
                <td>{{ log.applicationVersion || '-' }}</td>
                <td style="cursor:pointer; word-break:break-all; white-space:pre-wrap; max-width:400px" (click)="log.message && toggleMessage(log.logId)">
                  @if (!log.message) {
                    -
                  } @else if (expandedMessages.has(log.logId)) {
                    {{ log.message }}
                  } @else {
                    {{ log.message | slice:0:80 }}{{ log.message.length > 80 ? '...' : '' }}
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
        <br/>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-muted">
            Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + logs.length }} of {{ totalResults }} entries
          </small>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="pageNumber <= 1">
              <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
            </li>
            @for (page of getPageNumbers(); track $index) {
              @if (page === null) {
                <li class="page-item disabled"><span class="page-link">...</span></li>
              } @else {
                <li class="page-item" [class.active]="page === pageNumber">
                  <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                </li>
              }
            }
            <li class="page-item" [class.disabled]="logs.length < resultsPerPage">
              <button class="page-link" (click)="onClickPaginationNext()" [disabled]="logs.length < resultsPerPage">&raquo;</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
